import CryptoJS from 'crypto-js';

const CALLBACK_HASH_SECRET_KEY = process.env.REACT_APP_SECRET_KEY; // Get key from .env

export function pathnameFromUrl(url) {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch (e) {
    const path = String(url || "").split("?")[0];
    return path.startsWith("/") ? path : `/${path}`;
  }
}

export function applyHmacToAxiosConfig(config) {
  const headers = config.headers || {};
  const data = config.data;
  if (headers.userHmac || headers.userhmac) return config;
  if (typeof FormData !== "undefined" && data instanceof FormData) return config;
  if (data && typeof data === "object" && data.userHmac) return config;

  const method = String(config.method || "get").toUpperCase();
  const authorization = headers.Authorization || headers.authorization || "";
  const url = config.url || "";
  const noBody = data == null || method === "GET" || method === "HEAD" || method === "DELETE";

  if (noBody) {
    const time = Date.now().toString();
    const nonce = `${time}-${Math.random().toString(36).slice(2, 12)}`;
    const userHmac = createNewHmac({
      token: authorization,
      time,
      nonce,
      path: pathnameFromUrl(url),
      method,
    });
    config.headers = {
      ...headers,
      userHmac,
      "x-request-time": time,
      "x-request-nonce": nonce,
    };
    return config;
  }

  if (typeof data === "object") {
    data.userHmac = createNewHmac(data);
  }
  return config;
}

export function createNewHmac(data) {
  if (!CALLBACK_HASH_SECRET_KEY) {
    throw new Error("HMAC Secret Key is missing in environment variables.");
  }

  const hashResp = CryptoJS.SHA256(CALLBACK_HASH_SECRET_KEY);

  delete data.hmac;

  if ('actions' in data) {
    const actionss = data.actions
      .map((action) =>
        Object.keys(action)
          .sort()
          .map((key) => action[key])
          .join('')
      )
      .join('');

    data.actions = actionss;
  }

  const hmacbaseRes = Object.keys(data)
    .sort()
    .map((key) => data[key])
    .join('');

  const hmacResp = CryptoJS.HmacSHA256(hmacbaseRes, hashResp);
  return CryptoJS.enc.Hex.stringify(hmacResp);
}

export function verifyHmac(payload) {
  if (!CALLBACK_HASH_SECRET_KEY) {
    throw new Error("HMAC Secret Key is missing in environment variables.");
  }

  const base = { ...payload };
  delete base.hmac;

  if ('actions' in base) {
    let actions = '';
    for (const action of base.actions) {
      Object.keys(action)
        .sort()
        .forEach((key) => (actions += action[key]));
    }
    base.actions = actions;
  }

  const hash = CryptoJS.SHA256(CALLBACK_HASH_SECRET_KEY);
  const hmac = CryptoJS.HmacSHA256('', hash);

  let hmacBase = '';
  Object.keys(base)
    .sort()
    .forEach((key) => (hmacBase += base[key]));

  const hmacString = CryptoJS.HmacSHA256(hmacBase, hmac).toString(CryptoJS.enc.Hex);

  return hmacString === payload.hmac;
}
